import { createPageComponent } from "../utils/createPageComponent";
import { BaseErrorPage } from "../components/BaseErrorPage";

import { NotFoundErrorPageButtons } from "./Error404Buttons";

const Page = () => (
  <BaseErrorPage
    titleTransKey="notFoundError.title"
    infoTransKey="notFoundError.info"
    buttons={<NotFoundErrorPageButtons />}
  />
);

export const NotFoundErrorPage = createPageComponent(Page);
